module.exports = function() {
  return new Worker(__webpack_public_path__ + "e647d49b56ef20b5ae45.worker.js");
};